

























import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { QueryActivityGoodsAllList, DeleteActivityGoods,QueryAllShopNameList,BatchDeleteActivityGoods } from '@/api'
import { Message, MessageBox } from 'element-ui'
import { VTable, TableHander, VQuery , QueryModel, TableOperation } from '@/components/table'
import UpdateActivityGoodsDialog from './UpdateActivityGoodsDialog.vue'
import CreateActivityGoodsDialog from './CreateActivityGoodsDialog.vue'
import {PriceFormat} from '@/utils/tyepconvert'
import constant from '@/utils/constant'

@Component({
  components: { VQuery, VTable, UpdateActivityGoodsDialog, CreateActivityGoodsDialog },
})
export default class BindActivityGoodsDialog extends Vue {
  @Emit('close')
  private close() {
    this.show = false
    this.tableCurrntPage = 1
  }
  private show = false
  private activity: any = {}
  private shopIdOption: Array<any> = []
  private data = {}
  private tableData = []
  private tableTotal = 0
  private tableCurrntPage = 1
  private queryParam = {
    startRow: 1,
    limit: 10,
    sortType: 0,
  }
  private tableSelectData: any[] = []
  private tableSelectChange(e:any[]){
    console.log(e)
    this.tableSelectData = e
  }

  public open(data: any) {
    this.show = true
    this.data = {}
    this.activity = data
    this.loadData()
  }
  private shopIdQueryParam: QueryModel = { title: '店铺', param: 'shopId' , type: 'select', selectData:  this.shopIdOption}

  // 查询条件
  private queryModels: Array<QueryModel> = [
    { title: '排序方式', param: 'sortType' , type: 'select', selectData: constant.SortType},
    { title: '商品编号', param: 'goodsCode' },
    { title: '商品名称', param: 'goodsName' },
    this.shopIdQueryParam,
  ]
  // 全局操作
  private queryOperation: Array<TableOperation> = [
    { title: '添加商品', type: 'primary', click: this.addGoods},
    { title: '批量删除', type: 'danger', click: this.batchDelete},
  ]
  // 数据表头
  private tableHander: Array<TableHander> = [
    { title: '多选', type: 'selection' },
    { title: '序号', param: 'activityGoodsId', type: 'index' },
    { title: '店铺', param: 'shopId',formatter: this.shopNameForam, overflow: true },
    { title: '商品图片', param: 'goodsBanners' , width: 80 , type:'image', formatter: this.getGoodsBanner },
    { title: '商品编号', param: 'goodsCode' },
    { title: '商品名称', param: 'goodsName' },
    { title: '销售价', param: 'showPrice' ,formatter: this.showPriceFormat},
    { title: '商品状态', param: 'goodsStatus' ,formatter: (value: number) => value == 0? '已下架' : '已上架'},
    // { title: '销售金额', param: 'salesIntegral' ,formatter: PriceFormat},
    // { title: '奖励积分', param: 'rewardIntegral' ,formatter: PriceFormat},
    // { title: '活动销售金额', param: 'activitySalesIntegral' ,formatter: PriceFormat},
    // { title: '活动奖励积分', param: 'activityReturnIntegral' ,formatter: PriceFormat},
    { title: '活动库存(-1表示无限)', param: 'activityInventory'},
    { title: '活动中购买数量', param: 'activityBuyCount' },
    // { title: '商品排序', param: 'sort' },
    { title: '活动排序', param: 'activitySort'},
    {
      title: '操作',
      width: 200,
      operation: [
        { title: '修改', icon: 'el-icon-edit', click: this.openUpdate },
        { title: '删除', icon: 'el-icon-delete', class: 'red', click: this.deleteRow },
      ],
    },
  ]

  private getGoodsBanner(value: string){
    if(value){
      const vs = value.split(",")
      console.log("vs")
      console.log(vs)
      return vs[0]
    }
    return ""
  }
  
  // 显示价格
  private showPriceFormat(v:any,row:any){
    let showPrice = ''
    if(row.minPrice == row.maxPrice){
      showPrice = PriceFormat(row.minPrice)
    } else {
      showPrice = PriceFormat(row.minPrice) + '~' + PriceFormat(row.maxPrice)
    }
    return showPrice
  }

  // 显示店铺名称
  private shopNameForam(v:number){
    const t = this.shopIdOption.find(e=>e.value == v)
    if(t){
      return t.label
    }
    return v
  }

  public search() {
    this.tableCurrntPage = 1
    this.loadData()
  }

  public created(){
    this.loadShop()
  }

  private async loadShop() {
    const res = await QueryAllShopNameList({})
    const list = res.list
    this.shopIdOption = list.map((e: any) => {
      return { value: e.id, label: e.name }
    })

    this.shopIdQueryParam.selectData = this.shopIdOption

  }

  public async loadData() {
    // 排序
    const param: any = { ...this.queryParam,activityId: this.activity.id }
    if(this.queryParam.sortType == 0){
      param.orderBy = "activity_sort desc, sort desc, create_time desc"
    }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    const result = await QueryActivityGoodsAllList(param)
    this.tableData = result.list
    this.tableTotal = result.total
  }

  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }

  public addGoods() {
    const f = this.$refs.createActivityGoodsDialog as CreateActivityGoodsDialog
    f.open(this.activity)
  }
  public batchGoods() {
    console.log('批量添加商品')
  }
  public openUpdate(data: any) {
    const f = this.$refs.updateActivityGoodsDialog as UpdateActivityGoodsDialog
    f.open(data)
  }

  public batchDelete(){

    if(this.tableSelectData.length<=0){
        this.$message.error("请选择商品")
        return
    }
    MessageBox.confirm('确定要批量删除勾选的商品吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await BatchDeleteActivityGoods({ ids: this.tableSelectData.map(item=>item.id) })
      if (ruslt) {
        Message.success('批量删除成功')
        this.loadData()
      }
    })

  }

  public deleteRow(data: any) {
    MessageBox.confirm('确定要删除吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await DeleteActivityGoods({ id: data.activityGoodsId })
      if (ruslt) {
        Message.success('删除成功')
        this.loadData()
      }
    })
  }
}
